// Local components
import { gsap, ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);

import { SplitText } from "../components/gsap-split-text";

let mm = gsap.matchMedia();

document.addEventListener("DOMContentLoaded", (e) => {
	// ANIMATE TEXT HERO
	const intro_text = document.querySelector("[data-split-text]");
	const splitted_text = new SplitText(intro_text); // or new SplitText("h1.test")

	let animateIntroText = gsap.from(splitted_text.words, {
		yPercent: 100,
		autoAlpha: 0,
		ease: "sine.in",
		stagger: 0.12,
	});

	// Grow image on scroll
	const tl = gsap.timeline({
		ease: "none",
	});

	tl.add("start");

	tl.from(
		".animated-pic",
		{
			scale: 0.72,
			duration: 1,
			transformOrigin: "center center",
			onComplete: () => {
				stopObserving();
			},
		},
		"start"
	);

	tl.from(
		".banner-full__caption",
		{
			yPercent: 6,
			autoAlpha: 0,
			ease: "sine.in",
			onComplete: () => {
				stopObserving();
			},
		},
		"start"
	);

	ScrollTrigger.create({
		trigger: ".banner-full",
		start: `top ${document.querySelector(".header").getBoundingClientRect().height / 2}`,
		end: "+=100%",
		pin: "[data-grow-image]",
		animation: tl,
		scrub: 2,
		pinSpacing: "margin",
	});

	const section_contact = document.querySelector(".contact-block");
	if (section_contact) {
		ScrollTrigger.matchMedia({
			// desktop
			"(min-width: 992px)": function() {
				gsap.timeline({
					scrollTrigger: {
						trigger: section_contact,
						scrub: 1,
						start: "top 70%",
						end: "bottom 20%",
					},
				})
					.from('[data-gsap="pic-contact"]', {
						yPercent: 10,
						ease: "linear",
					})
					.from('[data-gsap="text-contact"]', {
						yPercent: -20,
						ease: "linear",
					})
					.from('[data-gsap="box-contact"]', {
						yPercent: -5,
						ease: "linear",
					});
			}
		});
	}

	// Dynamic numbers
	(function ($) {
		$.fn.jQuerySimpleCounter = function (options) {
			var settings = $.extend(
				{
					start: 0,
					end: 100,
					easing: "swing",
					duration: 400,
					complete: "",
				},
				options
			);

			var thisElement = $(this);

			$({ count: settings.start }).animate(
				{ count: settings.end },
				{
					duration: settings.duration,
					easing: settings.easing,
					step: function () {
						var mathCount = Math.ceil(this.count);
						thisElement.text(mathCount);
					},
					complete: settings.complete,
				}
			);
		};
	})(jQuery);

	function animate_key_metric(start, end, duration, counter_id) {
		// Si en cours, mais pas terminé => On stoppe
		if (jQuery(counter_id).attr("data-finished") == 0 && jQuery(counter_id).attr("data-launched") == 1) return;

		// Si terminé, mais plus dans le viewport => on réinitialise
		if (jQuery(counter_id).attr("data-finished") == 1 && !procab_bkr_obj_is_in_viewport(counter_id)) {
			jQuery(counter_id).attr("data-finished", 0);
			jQuery(counter_id).attr("data-launched", 0);
		}

		// Si terminé, et dans le viewport => on stoppé
		if (jQuery(counter_id).attr("data-finished") == 1 && procab_bkr_obj_is_in_viewport(counter_id)) return;

		// Si pas dans le viewport => stoppe
		if (!procab_bkr_obj_is_in_viewport(counter_id));

		// On lance l'affichages
		jQuery(counter_id).jQuerySimpleCounter({
			// start number
			start: start,

			// end number
			end: end,

			// easing effect
			easing: "swing",

			// duration time in ms
			duration: duration,

			complete: function () {
				jQuery(counter_id).attr("data-finished", 1);
			},
		});

		jQuery(counter_id).attr("data-launched", 1);
	}

	const dynamic_numbers = document.querySelectorAll(".boxes-number-slider [data-number]");
	dynamic_numbers.forEach((number) => {
		let start = number.getAttribute("data-start");
		let end = number.getAttribute("data-end");
		let duration = 5000;
		let counter_id = number;

		animate_key_metric(start, end, duration, counter_id);

		document.addEventListener("scroll", (event) => {
			animate_key_metric(start, end, duration, counter_id);
		});
	});

	/**
	 * Fix conflit with horizontal scroll animation
	 */

	// Select the node that will be observed for mutations
	const targetNodes = document.querySelectorAll("[data-horizontal-scroll]");

	// Options pour observer les mutations
	const config = { attributes: true, childList: true, subtree: true };

	// Timer pour limiter les appels à ScrollTrigger.refresh()
	let refreshTimeout;

	// Fonction callback déclenchée par les mutations
	const callback = (mutationList, observer) => {
		let needsRefresh = false;

		for (const mutation of mutationList) {
			// Vérifie si le type de mutation nécessite un rafraîchissement
			if (mutation.type === "attributes" || mutation.type === "childList") {
				needsRefresh = true;
				break; // Une seule modification suffit
			}
		}

		if (needsRefresh) {
			clearTimeout(refreshTimeout); // Empêche les rafraîchissements excessifs
			refreshTimeout = setTimeout(() => {
				ScrollTrigger.refresh();
			}, 100); // Rafraîchit avec un délai (100ms ici pour éviter trop d'appels)
		}
	};

	// Crée un observateur
	const observer = new MutationObserver(callback);

	// Cible les éléments à observer
	targetNodes.forEach((element) => {
		observer.observe(element, config);
	});
	// Arrêter l’observateur si nécessaire
	const stopObserving = () => {
		observer.disconnect();
	};
});
